export default __webpack_public_path__ + "static/media/question_12.4709a1d8.png";